import { useNavigate } from "react-router-dom";
import { paths } from "../../../../../../../Routes";

export const usePaymentResult = (paymentPlanLineId) => {
  const navigate = useNavigate();

  const navigateToPaymentPlanLineView = () => {
    return navigate(`${paths.PaymentView}/${paymentPlanLineId}`);
  };

  return { navigateToPaymentPlanLineView };
};
